"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.string.starts-with");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _communityComment = require("@/api/community/communityComment");
var _memberManagement = require("@/api/member/memberManagement");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'CommunityDynamicsDetail',
  props: {
    detailData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      imagePrefix: '',
      apiDetailData: {},
      // 评论数据
      commentList: [],
      total: 0,
      commentLoading: false,
      // 分页数据
      commentPage: {
        pageNum: 1,
        pageSize: 10,
        hasNextPage: false
      },
      // 滚动加载相关
      scrollLoading: false,
      scrollContainer: null,
      // 审核相关数据
      auditForm: {
        status: '',
        // 'agree' 或 'reject'
        reason: ''
      },
      auditRules: {
        status: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请输入审核理由',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 合并传入的数据和API获取的数据，优先使用API数据
    mergedDetailData: function mergedDetailData() {
      return _objectSpread(_objectSpread({}, this.detailData), this.apiDetailData);
    }
  },
  created: function created() {
    // 获取图片前缀
    this.fetchImagePrefix();
    // 如果有id，则调用接口获取详情数据
    if (this.detailData.id) {
      this.fetchDetailData(this.detailData.id);
    }
  },
  methods: {
    // 获取详情数据
    fetchDetailData: function () {
      var _fetchDetailData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              _context.next = 2;
              return (0, _communityComment.queryCommentInfo)(id);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.apiDetailData = response.data || {};
                // 获取评论数据
                this.fetchCommentData(id);
              } else {
                this.$message.error(response.message || '获取详情失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.error('获取详情失败: ' + _t.message);
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchDetailData(_x) {
        return _fetchDetailData.apply(this, arguments);
      }
      return fetchDetailData;
    }(),
    // 获取评论数据
    fetchCommentData: function () {
      var _fetchCommentData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(commentId) {
        var isLoadMore,
          params,
          response,
          _args2 = arguments,
          _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isLoadMore = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              if (!(isLoadMore && !this.commentPage.hasNextPage)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              // 设置加载状态
              if (isLoadMore) {
                this.scrollLoading = true;
              } else {
                this.commentLoading = true;
              }
              _context2.prev = 2;
              params = {
                commentId: commentId,
                page: isLoadMore ? this.commentPage.pageNum + 1 : 1,
                limit: this.commentPage.pageSize
              };
              _context2.next = 3;
              return (0, _communityComment.userContentComments)(params);
            case 3:
              response = _context2.sent;
              if (response.code === 200) {
                // 如果是加载更多，追加数据；否则替换数据
                if (isLoadMore) {
                  this.commentList = [].concat((0, _toConsumableArray2.default)(this.commentList), (0, _toConsumableArray2.default)(response.records || []));
                  this.commentPage.pageNum++;
                } else {
                  this.commentList = response.records || [];
                  this.commentPage.pageNum = 1;
                }
                this.total = response.total;
                // 检查是否还有下一页
                this.commentPage.hasNextPage = this.commentList.length < this.total;
              } else {
                this.$message.error(response.message || '获取评论数据失败');
              }
              _context2.next = 5;
              break;
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](2);
              this.$message.error('获取评论数据失败: ' + _t2.message);
            case 5:
              _context2.prev = 5;
              if (isLoadMore) {
                this.scrollLoading = false;
              } else {
                this.commentLoading = false;
              }
              return _context2.finish(5);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function fetchCommentData(_x2) {
        return _fetchCommentData.apply(this, arguments);
      }
      return fetchCommentData;
    }(),
    // 获取打标状态显示名称
    getIsTopDisplayName: function getIsTopDisplayName(isTop) {
      switch (isTop) {
        case 0:
          return '未打标';
        case 1:
          return '置顶';
        case 2:
          return '广告';
        case 3:
          return '官方';
        default:
          return '未打标';
      }
    },
    // 获取打标状态按钮类型
    getIsTopButtonType: function getIsTopButtonType(isTop) {
      switch (isTop) {
        case 0:
          return 'info';
        // 未打标
        case 1:
          return 'success';
        // 置顶
        case 2:
          return 'warning';
        // 广告
        case 3:
          return 'danger';
        // 官方
        default:
          return 'info';
      }
    },
    // 获取图片前缀
    fetchImagePrefix: function () {
      var _fetchImagePrefix = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取图片前缀失败:', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function fetchImagePrefix() {
        return _fetchImagePrefix.apply(this, arguments);
      }
      return fetchImagePrefix;
    }(),
    // 获取完整图片URL
    getImageUrl: function getImageUrl(imgPath) {
      // 如果已经是完整URL，则直接返回
      if (imgPath && (imgPath.startsWith('http://') || imgPath.startsWith('https://'))) {
        return imgPath;
      }
      // 使用动态获取的图片前缀
      return imgPath ? this.imagePrefix + imgPath : '';
    },
    // 格式化时间戳为日期字符串
    formatDate: function formatDate(timestamp) {
      if (!timestamp) return '';
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    // 返回上一页
    goBack: function goBack() {
      // 通过事件通知父组件关闭当前标签页
      this.$emit('go-back');
    },
    // 提交审核
    handleAuditSubmit: function handleAuditSubmit() {
      var _this = this;
      this.$refs.auditForm.validate(function (valid) {
        if (valid) {
          // 构造审核请求数据
          var auditData = {
            commentId: _this.mergedDetailData.id,
            remark: _this.auditForm.reason,
            status: _this.auditForm.status === 'agree' ? 1 : 0 // 1为同意，0为拒绝
          };

          // 调用审核接口
          (0, _communityComment.userContentAudit)(auditData).then(function (response) {
            if (response.code === 200) {
              _this.$message.success('审核成功');
              // 重新加载详情数据以更新状态
              _this.fetchDetailData(_this.mergedDetailData.id);
              // 通知父组件审核完成
              _this.$emit('audit-complete');
            } else {
              _this.$message.error(response.message || '审核失败');
            }
          }).catch(function (error) {
            _this.$message.error('审核失败: ' + error.message);
          });
        } else {
          _this.$message.warning('请填写完整的审核信息');
          return false;
        }
      });
    },
    // 滚动事件处理
    handleScroll: function handleScroll(event) {
      var _event$target = event.target,
        scrollTop = _event$target.scrollTop,
        clientHeight = _event$target.clientHeight,
        scrollHeight = _event$target.scrollHeight;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.loadMoreComments();
      }
    },
    // 加载更多评论
    loadMoreComments: function loadMoreComments() {
      // 如果正在加载或没有更多数据，则不执行
      if (this.scrollLoading || !this.commentPage.hasNextPage) {
        return;
      }
      this.fetchCommentData(this.mergedDetailData.id, true);
    },
    // 新增的评论相关方法
    // 切换回复显示
    toggleReply: function toggleReply(comment) {
      this.$set(comment, 'showReplies', !comment.showReplies);
    },
    // 显示所有回复
    showAllReply: function () {
      var _showAllReply = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(parentId, commentId) {
        var params, response, comment, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              params = {
                commentId: commentId,
                parentId: parentId
              };
              _context4.next = 1;
              return (0, _communityComment.userContentCommentsChild)(params);
            case 1:
              response = _context4.sent;
              if (response.code === 200) {
                // 更新评论的回复列表
                comment = this.commentList.find(function (c) {
                  return c.commentId === parentId;
                });
                if (comment) {
                  this.$set(comment, 'parentList', response.data || []);
                  this.$set(comment, 'showReplies', true);
                }
              } else {
                this.$message.error(response.message || '获取回复失败');
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              this.$message.error('获取回复失败: ' + _t4.message);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function showAllReply(_x3, _x4) {
        return _showAllReply.apply(this, arguments);
      }
      return showAllReply;
    }(),
    // 删除评论
    handleDeleteReply: function handleDeleteReply(replyId) {
      var _this2 = this;
      this.$confirm('确定要删除该回复吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _communityComment.userContentReplyDelete)(replyId).then(function (response) {
          if (response.code === 200) {
            _this2.$message.success('删除成功');
            // 重新加载评论数据
            _this2.fetchCommentData(_this2.mergedDetailData.id);
          } else {
            _this2.$message.error(response.message || '删除失败');
          }
        }).catch(function (error) {
          _this2.$message.error('删除失败: ' + error.message);
        });
      }).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    // 切换回复置顶状态
    handleToggleReplyTop: function handleToggleReplyTop(reply) {
      var _this3 = this;
      (0, _communityComment.userContentReplyTop)(reply.commentId).then(function (response) {
        if (response.code === 200) {
          _this3.$message.success('操作成功');
          // 切换置顶状态
          reply.isTop = reply.isTop === 1 ? 0 : 1;
        } else {
          _this3.$message.error(response.message || '操作失败');
        }
      }).catch(function (error) {
        _this3.$message.error('操作失败: ' + error.message);
      });
    }
  }
};